import * as QRCode from 'qrcode';
import * as pako from 'pako';

export function urlEncodeStringArray(inputArray: string[]): string {
    let encodedString = inputArray.map(encodeURIComponent).join('.');
    return encodedString;
}


export function decodeStringToArray(encodedString: string): string[] {
    let decodedArray = decodeURIComponent(encodedString).split('.');
    return decodedArray;
}

export async function generateQRCode(data: string): Promise<string> {
  try {
    const qr = await QRCode.toDataURL(data);
    return qr;
  } catch (err) {
    console.error(err);
    return '';
  }
}


export function dict2blob(dict: {[key: string]: any}): Blob {
  const jsonString = JSON.stringify(dict);
  const textEncoder = new TextEncoder();
  const binaryData = textEncoder.encode(jsonString);
  const compressedData = pako.deflate(binaryData);

  // Create a Blob from the compressed data
  const blob = new Blob([compressedData], { type: 'application/octet-stream' });

  return blob;
}

export async function blob2dict(blob: Blob): Promise<{[key: string]: any}> {
  // Convert the Blob to an ArrayBuffer
  const arrayBuffer = await blob.arrayBuffer();

  // Create a Uint8Array from the ArrayBuffer
  const uint8Array = new Uint8Array(arrayBuffer);

  // Decompress the data using pako
  const decompressedData = pako.inflate(uint8Array);

  // Convert the binary data to a JSON string using TextDecoder
  const textDecoder = new TextDecoder();
  const jsonString = textDecoder.decode(decompressedData);

  // Parse the JSON string back into a dictionary
  const dict = JSON.parse(jsonString);

  return dict;
}


export function downloadBlob(blob: Blob, filename: string) {
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}

function hasKeys(dict: {[key: string]: any}, keys: string[]): boolean {
  return keys.every(key => key in dict);
}

export async function getValidPecs(acceptedFiles: File[]): Promise<{[key: string]: any}[]> {
  const validDicts: {[key: string]: any}[] = [];

  const promises = acceptedFiles.filter(file => file.name.endsWith('.pecs')).map((file) => {
    return new Promise<void>((resolve) => {
      const reader = new FileReader();

      reader.onload = async () => {
        // reader.result contains the contents of blob as a typed array
        const arrayBuffer = reader.result as ArrayBuffer;
        const blob = new Blob([arrayBuffer], { type: file.type });

        // Now you can call your validation function
        let dict = await blob2dict(blob);
        // only mandatory keys, 'l2Audio','cachedLocalAutoL2image' not needed
        const validKeys = ['nodes', 'l2Image']; 
        if(hasKeys(dict, validKeys)){
          dict = Object.keys(dict)
            .filter(key => validKeys.includes(key))
            .reduce((obj, key) => {
              obj[key] = dict[key];
              return obj;
            }, {} as {[key: string]: any});

          validDicts.push(dict);
        }
        resolve();
      };

      reader.readAsArrayBuffer(file);
    });
  });

  await Promise.all(promises);
  return validDicts;
}

export async function compressImageBeforeImport(base64: string): Promise<string> {
  const newHeight = 300;
  return new Promise((resolve, reject) => {
      const img = new Image();
      img.onload = () => {
          const canvas = document.createElement('canvas');
          const ctx = canvas.getContext('2d');
          if (!ctx) {
              reject('Unable to get 2D context');
              return;
          }
          
          // Calculate the new width based on the original aspect ratio
          const aspectRatio = img.width / img.height;
          const newWidth = newHeight * aspectRatio;

          // Set the canvas dimensions and draw the image onto it
          canvas.width = newWidth;
          canvas.height = newHeight;
          ctx.drawImage(img, 0, 0, newWidth, newHeight);

          // Get the resized image as a base64 string
          // Convert to JPEG with a quality setting of 0.8
          const resizedImageBase64 = canvas.toDataURL('image/jpeg',0.95);
          resolve(resizedImageBase64);
      };
      img.onerror = (err) => {
          reject(err);
      };
      img.src = base64;
  });
}


/*
  // Get pixel color at (x, y)
  export function getPixelColor(imageData: ImageData, x: number, y: number): {r: number, g: number, b: number, a: number} {
    const i = (y * imageData.width + x) * 4;
    return {
      r: imageData.data[i],
      g: imageData.data[i + 1],
      b: imageData.data[i + 2],
      a: imageData.data[i + 3],
    };
  }
  
  // Set pixel color at (x, y)
  export function setPixelColor(imageData: ImageData, x: number, y: number, color: {r: number, g: number, b: number, a: number}): void {
    const i = (y * imageData.width + x) * 4;
    imageData.data[i] = color.r;
    imageData.data[i + 1] = color.g;
    imageData.data[i + 2] = color.b;
    imageData.data[i + 3] = color.a;
  }
  
  // Convert ImageData to base64
  export function imageDataToBase64(imageData: ImageData): string {
    const canvas = document.createElement('canvas');
    canvas.width = imageData.width;
    canvas.height = imageData.height;
    const ctx = canvas.getContext('2d');
    if (!ctx) {
      throw new Error('Could not get 2D context from canvas');
    }
    ctx.putImageData(imageData, 0, 0);
    return canvas.toDataURL();
  }



   // Convert base64 image to ImageData
export function base64ToImageData(base64: string): Promise<ImageData> {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.onload = () => {
      const canvas = document.createElement('canvas');
      canvas.width = img.width;
      canvas.height = img.height;
      const ctx = canvas.getContext('2d');
      if (!ctx) {
        reject(new Error('Could not get 2D context from canvas'));
        return;
      }
      ctx.drawImage(img, 0, 0);
      resolve(ctx.getImageData(0, 0, canvas.width, canvas.height));
    };
    img.onerror = reject;
    img.src = base64;
  });
}*/